function CollapseDetails({ object, onDelete, onEdit }) {
  const onClickEdit = () => {
    onEdit(object?.id);
  };

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex gap-1">
        <label className="fw-bold text-muted">TIN :</label>
        <p className="m-0">{object?.tinNo || "N/A"}</p>
      </div>

      <div className="d-flex gap-2">
        <button
          className="btn bg-primary text-white text-center fw-bold"
          onClick={onClickEdit}
        >
          <i className="bi bi-pencil me-2"></i>
          Edit
        </button>
        {/* <button
          className="btn btn-danger btn-md col-3 col-md-2 col-lg-1 text-center"
          onClick={onDelete}
        >
          <i className="bi bi-trash me-2"></i>
          Delete
        </button> */}
      </div>
    </div>
  );
}

export default CollapseDetails;
